module.exports = __webpack_public_path__ + "static/media/DSC_7364.e46bc9f4.jpg";